import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from "@stripe/react-stripe-js";
import { useEffect } from "react";
import "./PaymentForm.scss";

const ELEMENT_OPTIONS = {
  style: {
    base: {
      color: "#ffffff", // White text for dark background
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      fontSmoothing: "antialiased",
      fontSize: "16px",
      "::placeholder": {
        color: "#888",
      },
    },
    invalid: {
      color: "#ff4444",
      iconColor: "#ff4444",
    },
  },
};

export default function PaymentForm({ onCardChange }) {
  console.log("[PaymentForm] Rendering PaymentForm component");

  useEffect(() => {
    console.log("[PaymentForm] Component mounted");
  }, []);

  const handleChange = (event) => {
    console.log("[PaymentForm] Card element change:", event);
    if (onCardChange) {
      onCardChange(event);
    }
  };

  return (
    <div className="payment-form">
      <div className="card-element-wrapper">
        <CardNumberElement
          options={ELEMENT_OPTIONS}
          onChange={handleChange}
          onReady={() => console.log("[PaymentForm] CardNumber ready")}
        />
      </div>

      <div className="card-row">
        <div className="card-element-wrapper card-element-half">
          <CardExpiryElement
            options={ELEMENT_OPTIONS}
            onChange={handleChange}
            onReady={() => console.log("[PaymentForm] CardExpiry ready")}
          />
        </div>

        <div className="card-element-wrapper card-element-half">
          <CardCvcElement
            options={ELEMENT_OPTIONS}
            onChange={handleChange}
            onReady={() => console.log("[PaymentForm] CardCvc ready")}
          />
        </div>
      </div>
    </div>
  );
}
